var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaboratorsUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97786 1.90625C8.24023 1.90625 9.26358 2.9296 9.26358 4.19196V5.71577C9.26358 6.97814 8.24023 8.00149 6.97786 8.00149C5.7155 8.00149 4.69215 6.97814 4.69215 5.71577V4.19196C4.69215 2.9296 5.7155 1.90625 6.97786 1.90625ZM12.3112 12.5729V12.0181C12.3112 9.59038 9.5026 8.00149 6.97786 8.00149C4.45313 8.00149 1.64453 9.59038 1.64453 12.0181V12.5729C1.64453 12.9937 1.98565 13.3348 2.40644 13.3348H11.5493C11.9701 13.3348 12.3112 12.9937 12.3112 12.5729Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0425 2.03906C10.9224 2.35709 11.5512 3.19976 11.5512 4.18929V4.95119C11.5512 5.93944 10.9054 6.91794 10.0273 7.23691C10.5411 6.53689 10.7976 5.6478 10.7968 4.56962C10.7961 3.49145 10.5447 2.64793 10.0425 2.03906ZM13.8369 13.3321H14.5988C15.0196 13.3321 15.3607 12.991 15.3607 12.5702C15.3607 12.3853 15.3607 12.2004 15.3607 12.0154C15.3607 10.3622 14.0582 9.09797 12.43 8.45959C12.43 8.45959 14.5988 10.2845 13.8369 13.3321Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboratorsUsersIcon);
export default __webpack_public_path__ + "static/media/CollaboratorsUsersIcon.9eac9f448623d9dd538c83b7f72aaaa8.svg";
export { ForwardRef as ReactComponent };